import wrapNode from "../../utils/wrapNode";
import createTemplate from "../../utils/createTemplate";
import getDevice from "../../utils/getDevice";
import { openPopup } from "./common";
import createElementChangeListener from "../../elementChangeListener";

const wrapperTemplate = createTemplate(`
<div class="share-tab-img share-buttons share-trigger"></div>`);

const sharesTemplate = createTemplate(`
<div class="share-media-panel">
    <ul class="social-tab-i">
        <li class="social-tab-buttons">
            <ul></ul>
        </li>
        <li class="close-share-mobile-wrap">
            <button class="close-share-mobile" title="Close sharing options">
                <span style="display:none;">Close sharing options</span>
                <i class="icons-share cls sprite-shares-close sprite-shares-small-close"></i>
            </button>
        </li>
        <li class="show-share-mobile-wrap">
            <button class="show-share-mobile" title="Show sharing options">
                <span style="display:none;">Show sharing options</span>
                <i class="icons-share cls sprite-shares-share sprite-shares-small-share"></i>
            </button>
        </li>
    </ul>
</div>`);

const shareItemTemplate = createTemplate(`
<li>
    <button class="share" target="_blank">
        <span style="display:none;"></span>
        <i class="icons-share"></i>
    </button>
</li>`);

function createPopupWithUrl(baseUrl, params) {
    openPopup(`${baseUrl}?${new URLSearchParams(params).toString()}`);
}

const providerUrlTemplates = {
    facebook(context) {
        const baseUrl = "http://www.facebook.com/dialog/feed";
        const params = {
            app_id: context.settings.fbId,
            display: "popup",
            link: `${window.location.href}?xrs=RebelMouse_fb#${context.image.id}`,
            picture: context.image.src,
            redirect_uri: `https://${window.location.host}/fb_exit.html?fb=${window.location.href}`,
        };
        createPopupWithUrl(baseUrl, params);
    },
    twitter(context) {
        const baseUrl = "https://twitter.com/intent/tweet";
        const params = {
            url: `${window.location.href}?xrs=RebelMouse_tw#${context.image.id}`,
            text: `${context.headline} via @`,
        };
        createPopupWithUrl(baseUrl, params);
    },
    pinterest(context) {
        const baseUrl = "https://www.pinterest.com/pin/create/button/";
        const params = {
            url: window.location.href,
            media: context.image.src,
            description: context.headline,
        };
        createPopupWithUrl(baseUrl, params);
    },
    tumblr(context) {
        const baseUrl = "https://www.tumblr.com/share";
        const params = {
            t: context.headline,
            u: `${window.location.href}#${context.image.id}`,
            v: 3,
        };
        createPopupWithUrl(baseUrl, params);
    },
    email(context) {
        const siteName = document
            .querySelector('meta[property="og:site_name"]')
            .getAttribute("content");

        const body = `Hey, found this on ${siteName}'s Front Page and thought you would like it: ${window.location.href}#${context.image.id}`;

        const mailToUrl =
            "mailto:?subject=" +
            encodeURIComponent(context.headline || "") +
            "&body=" +
            encodeURIComponent(body);

        const anchor = document.createElement("a");
        anchor.target = "_blank";
        anchor.href = mailToUrl;
        anchor.click();
    },
};

const providers = [
    { name: "facebook", alias: "fb", useShortClass: true },
    { name: "twitter", alias: "tw", useShortClass: true },
    { name: "pinterest", alias: "pt" },
    { name: "tumblr", alias: "tl" },
    { name: "email", alias: "em" },
];

const showShareMobile = function (event) {
    this.closest(".social-tab-i").classList.add("show-mobile-share-bar");
    event.preventDefault();
    event.stopPropagation();
};

const closeShareMobile = function (event) {
    this.closest(".social-tab-i").classList.remove("show-mobile-share-bar");
    event.preventDefault();
    event.stopPropagation();
};

const selector = [
    "[data-image-share-headline] img.rm-shortcode:not(.rm-resized-image)",
    ".body-description img.rm-shortcode:not(.rm-resized-image)",
    ".article-description img.rm-shortcode:not(.rm-resized-image)",
    ".body-description .rm-shortcode > img:not(.rm-resized-image)",
    ".article-description .rm-shortcode > img:not(.rm-resized-image)",
].join();

export default function bodyImageShares(settings) {
    createElementChangeListener(selector, (image) => {
        const wrapper = wrapperTemplate.getElement();
        const sharesContainer = sharesTemplate.getElement();
        const post = image.closest("div.body,.image-sharing");

        wrapNode(image, wrapper);

        if (getDevice() === "mobile") {
            sharesContainer
                .querySelector(".show-share-mobile")
                .addEventListener("click", showShareMobile);
            sharesContainer
                .querySelector(".close-share-mobile")
                .addEventListener("click", closeShareMobile);
        }

        providers.forEach(({ name, alias, useShortClass }) => {
            const shareItem = shareItemTemplate.getElement();
            const anchor = shareItem.querySelector("button");
            shareItem.querySelector("span").innerText = `Share using ${alias}`;
            anchor.classList.add(`share-${useShortClass ? alias : name}`);
            sharesContainer.querySelector(".social-tab-buttons > ul").appendChild(shareItem);

            shareItem
                .querySelector("i")
                .classList.add(alias, `sprite-shares-${name}`, `sprite-shares-small-${name}`);

            const headline = post.dataset.headline || post.dataset.imageShareHeadline;

            shareItem.addEventListener("click", (event) => {
                providerUrlTemplates[name]({ headline, image, settings });
                event.preventDefault();
                event.stopPropagation();
                return false;
            });
        });
        wrapper.appendChild(sharesContainer);
    });
}
